import { jsxs, jsx } from 'react/jsx-runtime';
import { themedColor, font, Flex } from '@lemonade-hq/cdk';
import { useContext, useMemo } from 'react';
import { useCookies } from 'react-cookie';
import styled, { css } from 'styled-components';
import { HEADER_LINKS_TAGGED_WITH_LABEL, DEFAULT_LINK_TARGETS } from '../../../config/links.esm.js';
import { getHeaderLinksByCountryAndRegion, isExternalHeaderLink } from '../../../helpers/links.esm.js';
import { urlWithPreventRedirect } from '../../../helpers/routes.esm.js';
import { CommonI18nContext } from '../../../providers/I18nProvider.esm.js';
import { NavContext } from '../../../providers/NavProvider.esm.js';
import { headerMediaBreakpoint } from './shared.esm.js';
import { Cookie } from '../../../config/cookies.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  pointer-events: none;\n\n  &:hover {\n    text-decoration: none;\n    cursor: default;\n  }\n\n  @media ",
        " {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  margin-right: 10px;\n  position: relative;\n\n  &:before {\n    content: attr(data-label);\n    background-color: ",
        ";\n    color: ",
        ";\n    ",
        ";\n    letter-spacing: 0.6px;\n    position: absolute;\n    border-radius: 3px;\n    right: -23px;\n    padding: 1px 1px 1px 2px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n      @media ",
        " {\n        flex-flow: row;\n        align-items: center;\n        height: 70px;\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  height: 100%;\n  flex-flow: column;\n  align-items: flex-start;\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n      @media ",
        " {\n        color: ",
        ";\n        & + & {\n          margin-left: 24px;\n          margin-top: 0;\n        }\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  color: ",
        ";\n  text-decoration: none;\n  cursor: pointer;\n\n  & + & {\n    margin-left: 0;\n    margin-top: 24px;\n  }\n\n  ",
        "\n\n  &[data-label] {\n    ",
        ";\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
var disabledNavItemStyle = css(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.metal;
}, headerMediaBreakpoint, function(param) {
    var theme = param.theme;
    return theme.colors.metal;
});
var newNavItemStyle = css(_templateObject1(), themedColor("lightPink"), themedColor("primary"), font("main", {
    fontSize: "7px",
    fontWeight: 900
}));
var NavContainer = styled(Flex)(_templateObject3(), function(param) {
    var isInMenu = param.isInMenu;
    return !isInMenu && css(_templateObject2(), headerMediaBreakpoint);
});
var NavItem = styled.a(_templateObject5(), font("main"), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var isInMenu = param.isInMenu;
    return !isInMenu && css(_templateObject4(), headerMediaBreakpoint, function(param) {
        var theme = param.theme;
        return theme.colors.night;
    });
}, newNavItemStyle, function(props) {
    return props.current && disabledNavItemStyle;
});
var HeaderContentLinks = function(param) {
    var _param_withLogin = param.withLogin, withLogin = _param_withLogin === void 0 ? false : _param_withLogin, links = param.links, _param_labeledItems = param.labeledItems, labeledItems = _param_labeledItems === void 0 ? HEADER_LINKS_TAGGED_WITH_LABEL : _param_labeledItems, _param_targets = param.targets, targets = _param_targets === void 0 ? DEFAULT_LINK_TARGETS : _param_targets, router = param.router, _param_onLinkClicked = param.onLinkClicked, onLinkClicked = _param_onLinkClicked === void 0 ? function() {} : _param_onLinkClicked, _param_isInMenu = param.isInMenu, isInMenu = _param_isInMenu === void 0 ? false : _param_isInMenu;
    var _labeledItems_region, _labeledItems_US;
    var _useContext = useContext(CommonI18nContext), region = _useContext.region, lang = _useContext.lang, t = _useContext.t;
    var nav = useContext(NavContext).nav;
    var _useCookies = _sliced_to_array(useCookies([
        Cookie.Geography
    ]), 1), cookies = _useCookies[0];
    var resolvedLinks = useMemo(function() {
        return links !== null && links !== void 0 ? links : getHeaderLinksByCountryAndRegion(cookies[Cookie.Geography]);
    }, [
        links,
        cookies
    ]);
    var _resolvedLinks_region_lang;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var headerNav = (_resolvedLinks_region_lang = resolvedLinks[region][lang]) !== null && _resolvedLinks_region_lang !== void 0 ? _resolvedLinks_region_lang : resolvedLinks.US.en;
    var _labeledItems_region_lang, _ref;
    var labeledItemsList = (_ref = (_labeledItems_region_lang = (_labeledItems_region = labeledItems[region]) === null || _labeledItems_region === void 0 ? void 0 : _labeledItems_region[lang]) !== null && _labeledItems_region_lang !== void 0 ? _labeledItems_region_lang : (_labeledItems_US = labeledItems.US) === null || _labeledItems_US === void 0 ? void 0 : _labeledItems_US.en) !== null && _ref !== void 0 ? _ref : {};
    var _router_route_endsWith;
    return /*#__PURE__*/ jsxs(NavContainer, {
        as: "nav",
        isInMenu: isInMenu,
        itemScope: true,
        itemType: "http://www.schema.org/SiteNavigationElement",
        children: [
            headerNav.map(function(item) {
                return isExternalHeaderLink(item) ? /*#__PURE__*/ jsx(NavItem, {
                    "data-event": "menu_".concat(item.name, "_clicked"),
                    "data-label": item.label,
                    isInMenu: isInMenu,
                    onClick: function() {
                        onLinkClicked();
                        item.action();
                    },
                    target: item.target,
                    children: item.name
                }, item.name) : /*#__PURE__*/ jsx(NavItem, {
                    current: (_router_route_endsWith = router === null || router === void 0 ? void 0 : router.route.endsWith(item.replaceAll("_", "-"))) !== null && _router_route_endsWith !== void 0 ? _router_route_endsWith : false,
                    "data-event": "menu_".concat(item, "_clicked"),
                    "data-label": labeledItemsList[item],
                    href: item === "home" ? urlWithPreventRedirect(nav[item]) : nav[item],
                    isInMenu: isInMenu,
                    itemProp: "url",
                    onClick: onLinkClicked,
                    target: targets[item],
                    children: t("header.".concat(item, ".title"))
                }, item);
            }),
            withLogin && /*#__PURE__*/ jsx(NavItem, {
                "data-event": "menu_login_clicked",
                href: nav.login,
                isInMenu: isInMenu,
                itemProp: "url",
                onClick: onLinkClicked,
                children: t("header.actions.login")
            }, "login")
        ]
    });
};

export { HeaderContentLinks };
